import { provideZoneChangeDetection } from "@angular/core";
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import { bootstrapApplication } from '@angular/platform-browser';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
defineLocale('es', esLocale);
registerLocaleData(localeEsAr, 'es-Ar');
bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch((err) => console.error(err));
